import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnviarMensajeComponent } from './enviar-mensajes/enviar-mensajes.component';

const routes: Routes = [{ path: '', component: EnviarMensajeComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MensajesRoutingModule {}
